import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProfileService } from '../../+profile/profile.service';
import { UserAccount } from 'app/services/userAccount.service';
import { countries } from 'countries-list';
import { AppConfigService } from 'app/services/app-config.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'shopping-location-modal',
  templateUrl: './shopping-location-modal.component.html',
  styleUrls: ['./shopping-location-modal.component.scss']
})
export class ShoppingLocationModalComponent implements OnInit {
  account: any = {};

  currentUserCountryCode;
  availableCountries = [{code: 'US'}];
  displayedCountries = [];
  isSelectOpen = false;
  isLoading = false;

  errors = {
    phone: '',
  };

  chosenCountry = {
    capital: '',
    continent: '',
    currency: '',
    emoji: '',
    emojiU: '',
    languages: [],
    name: '',
    native: '',
    phone: '',
    code: '',
  };

  @Output() hide = new EventEmitter();
  @Output() apply = new EventEmitter();

  constructor(
    private profileService: ProfileService,
    private userAccount: UserAccount,
    private appConfigService: AppConfigService,
    private toasterService: ToasterService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.load();
  }


  load() {
    this.isLoading = true;
    this.profileService.get().subscribe(account => {
      this.account = account;
      this.userAccount.set(account);
      this.currentUserCountryCode = this.account.country_code;
      this.chosenCountry = countries[this.currentUserCountryCode];
      this.isLoading = false;
    });
    this.availableCountries = this.appConfigService.config.countries;
    this.availableCountries.map(country => {
      this.displayedCountries.push(countries[country.code]);
      countries[country.code].code = country.code;
    });
  }

  updateUserCountry() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.account.country_code = this.chosenCountry.code;
    this.profileService.save(this.account).subscribe(
      account => {
        this.account = account;
        this.userAccount.set(account);
        this.translate
          .get('account_updated_successfully')
          .subscribe(message => {
            this.toasterService.pop('success', undefined, message);
          });
          this.apply.emit();
          this.isLoading = false;
      },
      response => {
        this.isLoading = false;
        const errors = response.error;
        if (errors.detail) {
          this.toasterService.pop('error', undefined, errors.detail);
        }
        this.account.errors = errors;
      }
    );
  }


  handleSelect(country) {
    this.chosenCountry = country;
    this.isSelectOpen = false;
  }

  toggleSelect() {
    this.isSelectOpen = !this.isSelectOpen;
  }

  close() {
    this.hide.emit();
  }

}
